const CURRENCY_KEYWORDS = [
  'amount',
  'fee',
  'fees',
  'payment',
  'paid',
  'pay',
  'salary',
  'wage',
  'cost',
  'price',
  'total',
  'expense',
  'expenses',
  'balance',
  'debt',
  'charge',
  'income',
  'revenue',
  'profit',
  'budget',
  'allowance',
  'bonus',
];

export function isCurrencyField(fieldName = '') {
  const normalized = String(fieldName)
    .toLowerCase()
    .replace(/[_-]+/g, ' ');

  return CURRENCY_KEYWORDS.some(keyword => (
    new RegExp(`\\b${keyword}\\b`, 'i').test(normalized)
  ));
}

export function getCurrencyFields(fields = []) {
  return fields.filter(isCurrencyField);
}

export function parseCurrencyValue(value) {
  if (value === undefined || value === null || value === '') {
    return 0;
  }

  const cleaned = String(value).replace(/[^\d.-]/g, '');
  const parsed = Number(cleaned);

  return Number.isFinite(parsed) ? parsed : 0;
}

export function formatNaira(value) {
  const numericValue = parseCurrencyValue(value);

  return new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN',
    maximumFractionDigits: 0,
  }).format(numericValue);
}

export function getCurrencyTotals(records = [], fields = []) {
  return getCurrencyFields(fields)
    .map(field => ({
      field,
      total: records.reduce((sum, record) => (
        sum + parseCurrencyValue(record.data?.[field])
      ), 0),
    }))
    .filter(item => item.total !== 0);
}
